import appCONST from './../constants/app.constants';
export default function AuthService(
    $window,
    sessionService,
    userService
) {
    'ngInject';

            const EXPIRE_AT = 'expire_at';
            const AGENT_API_KEY = 'agent_api_key';
            let loggingOut = false;

            Object.assign(this, {
                login,
                getAccessToken,
                setTokenExpiration,
                isTokenExpired,
                isLoggedIn,

                isAuthorizedAgentUrl,
                getCachedAgentApiKey,
                setAuthorizedAgent,
                cleanAuthorizedAgent,
            });

            function setTokenExpiration(seconds) {
                const date = new Date();
                date.setSeconds(date.getSeconds() + seconds);
                const tokenExpireDate = date.toISOString();
                sessionService.setSessionItem(EXPIRE_AT, tokenExpireDate);
            }

            function isTokenExpired() {
                const expirationDate = sessionService.getSessionItem(EXPIRE_AT);
                if (!expirationDate) {
                    return true;
                }
                const tokenExpireDateInSeconds = new Date(expirationDate).getTime() - 10 * 1000;
                return Date.now() > tokenExpireDateInSeconds;
            }

            function login(token, refreshToken, expireIn) {
                if (expireIn) {
                    setTokenExpiration(expireIn);
                }
                sessionService.create(token, refreshToken);
            }

            function getAccessToken() {
                return sessionService.getSessionItem('token');
            }

            function isLoggedIn() {
                return sessionService.hasLocalSession() || sessionService.hasStorageSession();
            }

            function isAuthorizedAgentUrl(state) {
                return !isLoggedIn()
                    && (
                        state && state.name.indexOf('main.atc.') > -1
                        || $window.location.hash.indexOf('search/atc/') > -1
                    );
            }

            function getCachedAgentApiKey() {
                if (isTokenExpired()) {
                    sessionService.setSessionItem(AGENT_API_KEY, null);
                    sessionService.setSessionItem(EXPIRE_AT, null);
                    return null;
                }
                return '' + sessionService.getSessionItem(AGENT_API_KEY);
            }

            function setAuthorizedAgent(apikey) {
                sessionService.setSessionItem(AGENT_API_KEY, '' + apikey);
                setTokenExpiration(1800);
            }

            function cleanAuthorizedAgent() {
                sessionService.setSessionItem(AGENT_API_KEY, null);
            }

            this.saveUser = function(user) {
                sessionService.getSessionItem('readOnlyMode', false);
                sessionService.setSessionItem('user', user);
                userService.setUser(user);
            };

            this.logout = function() {
                if (!loggingOut) {
                    loggingOut = true;
                    const currentLang = userService.getCountry() || 'unknown';

                    sessionService.destroy();
                    sessionService.clearSessionItem(EXPIRE_AT);
                    userService.clearUser();
                    userService.clearUserSettings();

                    const endpoint = `${appCONST.logoutUrl}?CountryCode=${currentLang}`;
                    $window.location.replace(endpoint);
                }
            };

            this.getAvailableServicesFromSessionStorage = function() {
                return sessionService.getSessionItem('availableServices');
            };

            this.saveAvailableServices = function(data) {
                sessionService.setSessionItem('availableServices', data);
                userService.clearUserSettings();
            };

            this.isSupplierEnabled = function(supplierId) {
                const services = this.getAvailableServicesFromSessionStorage();
                return services && angular.isArray(services.EnabledServices)
                    ? services.EnabledServices.indexOf(supplierId) >= 0
                    : false;
            };

            this.hasPermission = function(state) {
                const availableServices = this.getAvailableServicesFromSessionStorage();
                const url = state.name.split('.')[1];
                const urlToService = {
                    flights: 'IsFlightSearchAvailable',
                    eurostar: 'IsFlightSearchAvailable',
                    hotels: 'IsHotelSearchAvailable',
                    cars: 'IsCarSearchAvailable',
                    rails: 'IsRailSearchAvailable',
                };

                /**
                 * Available services specified and user has permission for this services
                 */
                return (availableServices && (!urlToService[url] || availableServices[urlToService[url]]))
                    || isAuthorizedAgentUrl(state);
            };

            this.dontHaveSearchPermission = function() {
                const availableServices = this.getAvailableServicesFromSessionStorage();
                return !availableServices.IsCarSearchAvailable
                    && !availableServices.IsFlightSearchAvailable
                    && !availableServices.IsHotelSearchAvailable
                    && !availableServices.IsRailSearchAvailable;
            };

            this.permissionRedirectPage = function(state) {
                const url = state.name.split('.')[1];
                let redirectState;

                if (url === 'flights' || url === 'eurostar') {
                    redirectState = 'main.hotels';
                } else if (url === 'hotels') {
                    redirectState = 'main.cars';
                } else if (url === 'cars') {
                    redirectState = 'main.ukrail.roundtrip';
                } else if (url === 'ukrail') {
                    redirectState = 'main.flights.roundtrip';
                }

                return redirectState;
            };
}



// WEBPACK FOOTER //
// ./src/app/services/authService.js